import { themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const listTitleClass = style({
  fontSize: themeVars.font.size.textLg,
  fontWeight: themeVars.font.weight.bold,
});

export const cardListWrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: themeVars.space.x8,
});

export const cardListWrapperCompactClass = style({
  paddingBottom: 0,
});

export const listHeaderClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: themeVars.space.x4,
  marginBottom: themeVars.space.x4,
});
